window.checkbox_background_color_change_operation = function(input_field_name, required_flag = false) {
	get_checkbox_wrapper_identifier_by_field_name(input_field_name)
		.removeClass(SELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME + " " + UNSELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME);
	checkbox_add_choosen_background_color_operation(input_field_name);
	if(required_flag) checkbox_background_color_reset_operation(input_field_name);
}

window.checkbox_add_choosen_background_color_operation = function(input_field_name) {
	get_checkbox_wrapper_identifier_by_field_name(input_field_name, true)
		.addClass(SELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME);
}

window.checkbox_background_color_reset_operation = function(input_field_name) {
	let choosen_checkbox = $(get_checkbox_indentifier_by_field_name(input_field_name, true));
	if(choosen_checkbox.length != 0) return;
	get_checkbox_wrapper_identifier_by_field_name(input_field_name)
		.addClass(UNSELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME);
}

window.initial_checkbox_background_color_set_operation = function(input_field_name, required_flag = false) {
	if($(get_checkbox_indentifier_by_field_name(input_field_name, true)).length == 0) return;
	checkbox_background_color_change_operation(input_field_name, required_flag);
}

window.service_options_initial_checkbox_background_color_set_operation = function() {
	initial_checkbox_background_color_set_operation("contact_forms_step1[service_option][correspondence_conditions][]");
	initial_checkbox_background_color_set_operation("contact_forms_step1[service_option][product_conditions][]");
}

function get_checkbox_indentifier_by_field_name(input_field_name, checked = false) {
	let checkbox_option_idenfifier_name = "input[name='" + input_field_name + "'][type='checkbox']";
	if(checked) checkbox_option_idenfifier_name += ":checked";
	return checkbox_option_idenfifier_name;
}

function get_checkbox_wrapper_identifier_by_field_name(input_field_name, checked = false) {
	let radio_option_indentifier = get_checkbox_indentifier_by_field_name(input_field_name, checked);
	return $(radio_option_indentifier).closest("." + CHECKBOX_AND_RADIO_OPTIONS_PARENT_WRAPPER_CLASSNAME);
}
